import { DText, Flex } from '../../../../../styles/CommonStyles'
import Text from '../../../../../core/utils/Text'
import DateTime from '../../../../common/utils/DateTime'
import UserLink from '../../../../common/utils/UserLink'
import RTableLayout from '../../../../responsive/layout/RTableLayout'
import Operation from '../../../../common/utils/Operation'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { FiatAccStatusBadge } from './stausBadge'

const RFiatAccountTable = ({ data }) => {
    const { data: recipients } = data
    const navigate = useNavigate()

    return (
        <RTableLayout data={data}>
            {recipients?.data?.map((item) => {
                const label = item.label
                const fullName = item.userId

                const isActive = item.meta?.isActive

                return (
                    <div
                        key={item._id}
                        style={{
                            border: '1px solid #eee',
                            borderRadius: 12,
                            padding: 12,
                            marginBottom: 12
                        }}
                        className='space-y-3'
                    >
                        {/* HEADER */}
                        <Flex justify="space-between">
                            <UserLink
                                _id={item.userId}
                                name={fullName}
                            />

                            <Operation
                                hasDetails
                                onDetailsClicked={() =>
                                    navigate(`/reports/due-payments/accounts/${item._id}`)
                                }
                            />
                        </Flex>

                        {/* LABEL */}
                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                <Text tid="name" />
                            </DText>
                            <DText fontSize="s" main>
                                {item?.user?.firstName || ''} {item?.user?.lastName || ''}
                            </DText>
                        </Flex>

                        {/* ACCOUNT ID */}
                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                <Text tid="account-id" />
                            </DText>
                            <DText fontSize="s" main>
                                <Text tid={item.accountId} />
                            </DText>
                        </Flex>


                        {/* STATUS */}
                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                <Text tid="kyc" />
                            </DText>
                            <FiatAccStatusBadge status={item.meta?.kyc?.status || item.kyc} >
                                <DText fontSize="s" main>
                                    <Text tid={item.meta?.kyc?.status || item.kyc} />
                                </DText>
                            </FiatAccStatusBadge>
                        </Flex>

                        {/* CREATED AT */}
                        <Flex justify="space-between">
                            <DText fontSize="s" main>
                                <Text tid="created-at" />
                            </DText>
                            <DateTime dt={item.createdAt} />
                        </Flex>
                    </div>
                )
            })}
        </RTableLayout>
    )
}

export default RFiatAccountTable;

const StatusBadge = styled.div`
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  color: ${({ status }) => (status === 'success' ? '#0a0' : '#999')};
  background-color: ${({ status }) =>
        status === 'success' ? 'rgba(0,170,0,0.1)' : 'rgba(150,150,150,0.1)'};
`
